module.exports = __webpack_public_path__ + "img/6_jornada.bc54253a.jpg";